import { Commit } from 'vuex';
import { AuthState } from '@/modules/Auth/store/state';

export interface AuthActionTypes{
    commit: Commit,
    state: AuthState,
    getters: any
}

export enum AuthAction {
    POST_LOGIN = 'AUTH_POST_LOGIN',
    VERIFIER_LOGIN = 'AUTH_VERIFIER_LOGIN',
}
